import { createContext, useContext } from 'react';

/**
 * Managers / team leads ("reviewers") only get the Candidates screen, scoped to their org units,
 * and evaluate CVs there. HR gets everything.
 */
const ViewerRoleContext = createContext<{ isReviewer: boolean }>({ isReviewer: false });

export const ViewerRoleProvider = ViewerRoleContext.Provider;

export const useIsReviewer = () => useContext(ViewerRoleContext).isReviewer;
